import { render, staticRenderFns } from "./BodySearch.vue?vue&type=template&id=f01c6c14&"
import script from "./BodySearch.vue?vue&type=script&lang=js&"
export * from "./BodySearch.vue?vue&type=script&lang=js&"
import style0 from "./BodySearch.vue?vue&type=style&index=0&id=f01c6c14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports